import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Popover, PopoverTrigger, PopoverContent} from '@/components/ui/popover'
import SortArrow from '../../assets/icons/sort-arrow'
import {useCioFacetSelector} from '@/context/cio-facet'
import {SET_SELECTED_SORT_OPTION} from '@/context/cio-facet'

export const SortPopover = ({'data-testid': dataTestId}) => {
    const [open, setOpen] = useState(false)
    const cioFacetContext = useCioFacetSelector((context) => context)
    const dispatchFacetFilters = useCioFacetSelector((context) => context?.dispatch)

    const togglePopover = () => {
        setOpen(!open)
    }

    const updateSortOption = (option) => {
        dispatchFacetFilters({type: SET_SELECTED_SORT_OPTION, payload: option})
        togglePopover()
    }

    return (
        <Popover open={open} onOpenChange={setOpen} data-testid={dataTestId || 'sortPopover'}>
            <PopoverTrigger
                onClick={togglePopover}
                className="flex"
                disabled={!cioFacetContext?.state?.sortOptions}
                data-testid={dataTestId || 'sortPopover-PopoverTrigger'}
            >
                <SortArrow height={'1.25rem'} data-testid={dataTestId || 'sortPopover-SortArrow'} />
                <label htmlFor="sort-order-select" className="cursor-pointer">
                    Sort
                </label>
            </PopoverTrigger>
            <PopoverContent
                className="w-auto"
                data-testid={dataTestId || 'sortPopover-PopoverContent'}
            >
                <ul className="flex flex-col">
                    {cioFacetContext?.state?.sortOptions?.map((option) => (
                        <li
                            key={`${option.sort_by}-${option.sort_order}`}
                            className="hover:text-white hover:bg-accent"
                        >
                            <button
                                className={`p-2 w-full text-left ${
                                    option.status === 'selected' ? 'font-bold' : ''
                                }`}
                                onClick={() => updateSortOption(option)}
                            >
                                {option.display_name === 'Best Matches'
                                    ? 'Best Sellers'
                                    : option.display_name}
                            </button>
                        </li>
                    ))}
                </ul>
            </PopoverContent>
        </Popover>
    )
}
SortPopover.propTypes = {
    'data-testid': PropTypes.string
}

export default SortPopover

export const SortPopoverDefinition = {
    component: SortPopover,
    name: 'SortPopover',
    nowrap: true
}
